// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".RB7iODex{max-width:54.38rem}.RB7iODex .heading-form{margin-bottom:0}.E2HMPnnO{padding-top:1rem}.FAIt6u65>*{flex-basis:100%}.VJBBrwmO{display:flex;gap:1rem}@media(max-width:991.98px){.VJBBrwmO{gap:.9rem}}@media(max-width:767.98px){.VJBBrwmO{flex-wrap:wrap;gap:.5rem}}.fyn-BOPP{display:flex;gap:5rem}@media(max-width:991.98px){.fyn-BOPP{gap:4.5rem}}@media(max-width:767.98px){.fyn-BOPP{flex-wrap:wrap;gap:2.5rem}}.U8Q7BKtv,.fyn-BOPP,.VJBBrwmO{flex-direction:column;max-width:100%}.U8Q7BKtv,.FAIt6u65{display:flex;gap:1.75rem}@media(max-width:991.98px){.U8Q7BKtv,.FAIt6u65{gap:1.58rem}}@media(max-width:767.98px){.U8Q7BKtv,.FAIt6u65{flex-wrap:wrap;gap:.88rem}}.q9fznydU,._5TJr9fA\\+{gap:.5rem;max-width:100%}@media(max-width:767.98px){.q9fznydU,._5TJr9fA\\+{gap:.38rem}.q9fznydU>button,._5TJr9fA\\+>button{font-size:.81rem;text-align:left;white-space:normal!important;word-break:break-word}.jJdbgwag{font-size:.88rem}}.I8OqOhy3{margin-bottom:1em}.IDoAfDJK{font-size:1rem;line-height:1.39;max-width:50ch}.j3b9bHD\\+{color:#d91413;font-size:.75rem;line-height:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "RB7iODex",
	"containerPadded": "E2HMPnnO",
	"gap": "FAIt6u65",
	"colSm": "VJBBrwmO",
	"colLg": "fyn-BOPP",
	"col": "U8Q7BKtv",
	"companies": "q9fznydU",
	"interests": "_5TJr9fA+",
	"submitBtn": "jJdbgwag",
	"heading": "I8OqOhy3",
	"modalText": "IDoAfDJK",
	"error": "j3b9bHD+"
};
module.exports = ___CSS_LOADER_EXPORT___;
